module.exports = __webpack_public_path__ + "static/media/NAS.90f08651.svg";